<template>
  <div class="container">
    <div class="mwow-detail-header">
      <div class="left">
        <div class="back-btn" @click="handleBack">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
      </div>
      <div class="mid">
        <p>{{ activity_id ? "编辑活动" : "创建活动" }}</p>
      </div>
    </div>
    <el-image
      v-show="false"
      :src="activityContentData.cover_list.annex_content"
      :preview-src-list="[activityContentData.cover_list.annex_content]"
      id="elImageCover"
    >
    </el-image>
    <el-image
      v-show="false"
      :src="viewImagePromotionUrl"
      :preview-src-list="[viewImagePromotionUrl]"
      id="elImagePromotion"
      style="cursor: pointer"
    >
    </el-image>
    <!-- 活动内容 -->
    <div class="activity-type">
      <el-form
        size="medium"
        :model="activityContentData"
        ref="activityTypeForm"
        inline
        class="left-content"
      >
        <template v-if="currentStep === 'activityInfo'">
          <el-form-item label="活动内容" class="title-level1"> </el-form-item>
          <el-form-item label="活动类型:" prop="type" class="require">
            <el-select
              v-model="activityContentData.type"
              placeholder="请选择活动类型"
              clearable
              @clear="handleSearchType('')"
              filterable
              :filter-method="handleSearchType"
              @visible-change="handleTypeVisible($event, 'type')"
            >
              <el-option
                v-for="item in activityTypeList"
                :key="item.type_id"
                :label="item.title"
                :value="item.type_id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="活动名称:" prop="title" class="require">
            <el-input
              v-model="activityContentData.title"
              placeholder="请填写活动名称，最多18字"
              maxlength="18"
              clearable
            >
            </el-input>
          </el-form-item>

          <el-form-item
            label="活动时间:"
            prop="time"
            class="require activity-time"
          >
            <el-date-picker
              v-model="activityContentData.time"
              type="datetimerange"
              range-separator="至"
              start-placeholder="活动开始时间"
              end-placeholder="活动结束时间"
              format="yyyy-MM-dd HH:mm:ss"
              :picker-options="effectiveDate"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="活动库存:" prop="stock" class="require">
            <el-input
              v-model="activityContentData.stock"
              placeholder="请填写活动库存数量"
              type="number"
              clearable
              oninput="if (value.length>9) value=value.slice(0,9)"
              @change="handleStockChange"
            >
            </el-input>
          </el-form-item>

          <el-form-item label="活动封面:" prop="cover">
            <div class="tip">
              <span class="desc">（上传750*422 px尺寸图片、16:9视频）</span>
            </div>

            <image-video-uploader
              :originUrl.sync="activityContentData.cover_list.annex_content"
              :sizeLimit="1"
              :receiveResource="imageVideoUploaderData.receiveResourceCover"
              @change="handleImageVideoUploader"
              @clear="handleImageVideoClear"
              @choose="mediaCheck($event, 'cover')"
              @selected="handleSelected($event)"
              @listen="handleListenPercent"
              @uploading="handleUploading"
            >
              <div class="cover-uploader uploader">
                <template
                  v-if="activityContentData.cover_list.annex_type === 1"
                >
                  <img
                    v-if="activityContentData.cover_list.annex_content"
                    :src="activityContentData.cover_list.annex_content"
                    @click="handlePreviewImageCover"
                    style="cursor: pointer !important"
                    id="coverIamge"
                    width="377"
                    height="212"
                  />
                </template>

                <template
                  v-if="activityContentData.cover_list.annex_type === 2"
                >
                  <video
                    v-if="activityContentData.cover_list.annex_content"
                    :src="activityContentData.cover_list.annex_content"
                    controls
                    width="377"
                    height="212"
                  ></video>
                </template>
              </div>
            </image-video-uploader>
          </el-form-item>

          <el-form-item label="表单信息:" prop="info">
            <div class="tip">
              <span class="desc">（长按表单项，鼠标拖动上下排序位置）</span>
            </div>
            <div
              class="ul"
              @dragstart="handleDragstart"
              @dragenter="handleDragenter"
              @dragover="handleDragover"
            >
              <div
                class="li"
                v-for="item in activityContentData.form_list"
                :key="item.preset_form_id"
                draggable
              >
                <div class="title" @click="editFormItem(item)">
                  <!-- 优化，避免拖动元素 dom 选错导致排序紊乱 -->
                  {{
                    item.preset_form_id > 6
                      ? item.title + " (单击可编辑)"
                      : item.preset_form_id === 1 || item.preset_form_id === 4
                      ? item.title + " (固定项，不可关闭)"
                      : item.title
                  }}
                </div>
                <span v-show="false" class="preset_form_id">
                  {{ item.preset_form_id }}
                </span>
                <el-switch
                  v-model="item.is_show"
                  :disabled="
                    item.preset_form_id === 1 || item.preset_form_id === 4
                  "
                ></el-switch>
              </div>
            </div>
          </el-form-item>

          <el-form-item class="item7">
            <div class="operation">
              <el-button
                class="mwow-button success large bg"
                @click="handleCustomDialog('input')"
              >
                <span>文本框 +</span>
              </el-button>
              <el-button
                class="mwow-button success large bg"
                @click="handleCustomDialog('radio')"
              >
                <span>单选框 +</span>
              </el-button>
              <el-button
                class="mwow-button success large bg"
                @click="handleCustomDialog('checkbox')"
              >
                <span>多选框 +</span>
              </el-button>
            </div>
          </el-form-item>
        </template>

        <template v-if="currentStep === 'promotionSetting'">
          <el-form-item label="活动内容" class="title-level1"> </el-form-item>
          <el-form-item label="支付设置" class="title-level2"> </el-form-item>
          <el-form-item label=" ">
            <div class="tip">
              <span class="custom">
                <span>开启支付</span>
              </span>
              <el-switch
                v-model="activityContentData.is_pay"
                :disabled="!!$route.query.activity_id"
                v-if="onlinePay"
              ></el-switch>
            </div>
          </el-form-item>

          <open-pay
            v-if="activityContentData.is_pay"
            @dataChange="handleDataChange"
            :originData="payData"
          ></open-pay>
          <div v-if="!onlinePay" class="unOpenPay">
            <div class="unOpenPay-text">
              您还未开通乐沃收银，无法创建支付类型活动，推销小课包或课程
            </div>
            <el-button
              class="mwow-button-filled success large"
              @click="handleOpenPayClick"
            >
              立即开通
            </el-button>
          </div>

          <el-form-item label="推广设置" class="title-level2"> </el-form-item>
          <el-form-item label=" ">
            <div class="tip">
              <span class="custom">
                <span>客户提交后的引流页</span>
              </span>
              <el-switch
                v-model="activityContentData.is_promotion"
                @change="handleIsPromotion"
              ></el-switch>
            </div>
          </el-form-item>

          <template v-if="activityContentData.is_promotion">
            <el-form-item
              label="引流标题:"
              :class="{ require: activityContentData.is_promotion }"
            >
              <el-input
                placeholder="请输入引流标题，最多18字"
                maxlength="18"
                v-model="activityContentData.promotion.title"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="引流图片:"
              prop="img"
              :class="{ require: activityContentData.is_promotion }"
            >
              <div class="tip">
                <span class="desc">（上传650*650px尺寸）</span>
              </div>
              <image-video-uploader
                v-if="activityContentData.image_list.length === 0"
                :sizeLimit="1"
                accept=".jpeg,.jpg,.png"
                @change="handleImageUploader($event, 'image_list')"
                style="margin: 5px"
                :receiveResource="
                  imageVideoUploaderData.receiveResourcePromotion
                "
                @choose="mediaCheck($event, 'image')"
                @selected="handleSelected($event)"
              >
                <div class="promotion-uploader uploader"></div>
              </image-video-uploader>
              <template v-else>
                <image-video-uploader
                  v-for="(item, index) in activityContentData.image_list"
                  :key="item.annex_content"
                  :originName.sync="item.annex_content"
                  :originUrl.sync="item.annex_content"
                  :sizeLimit="1"
                  accept=".jpeg,.jpg,.png"
                  @change="handleImageUploader($event, 'image_list')"
                  @clear="handleImageClear(index, 'image_list')"
                  style="margin: 5px"
                >
                  <div class="promotion-uploader uploader">
                    <img
                      v-if="item.annex_content"
                      :src="item.annex_content"
                      width="120"
                      height="120"
                      @click="handlePreviewImagePromotion(item)"
                      style="cursor: pointer !important"
                    />
                  </div>
                </image-video-uploader>
              </template>
            </el-form-item>

            <el-form-item label="引流图片指引语:">
              <el-input
                placeholder="请输入图片指引语，最多36字"
                maxlength="36"
                v-model="activityContentData.promotion.quotation"
              ></el-input>
            </el-form-item>
          </template>

          <el-form-item label="推广说明:" prop="plain">
            <div class="tip">
              <span class="desc">（上传750px尺寸，最多6张）</span>
              <el-switch
                v-model="activityContentData.is_desc"
                @change="handleIsDesc"
              ></el-switch>
            </div>

            <template v-if="activityContentData.is_desc">
              <image-video-uploader
                v-if="copyDescList.length < 6"
                :sizeLimit="1"
                @change="handleImageUploader($event, 'desc_list')"
                style="margin: 5px"
                :receiveResource="
                  imageVideoUploaderData.receiveResourcePromotion
                "
                @listen="handleListenPercent"
                @uploading="handleUploading"
                @choose="mediaCheck($event, 'desc')"
                @selected="handleSelected($event)"
              >
                <div class="desc-uploader uploader">
                  <img />
                </div>
              </image-video-uploader>
              <image-video-uploader
                v-for="(item, index) in copyDescList"
                :key="index"
                :originUrl.sync="item.annex_content"
                :sizeLimit="1"
                accept=".jpeg,.jpg,.png"
                @change="handleImageUploader($event, 'desc_list')"
                @clear="handleImageClear(index, 'desc_list')"
                style="margin: 5px"
              >
                <div
                  class="desc-uploader uploader"
                  width="180"
                  height="102"
                  v-if="item.annex_type !== 3"
                >
                  <img
                    v-if="item.annex_type === 1"
                    :src="item.annex_content"
                    @click="handlePreviewImagePromotion(item)"
                    style="cursor: pointer !important"
                    width="180"
                    height="102"
                  />
                  <video
                    v-if="item.annex_type === 2"
                    :src="item.annex_content"
                    controls
                    width="180"
                    height="102"
                  ></video>
                </div>
              </image-video-uploader>
            </template>
          </el-form-item>

          <template v-if="activityContentData.is_desc">
            <el-form-item v-if="descriptionInput" class="item7">
              <div class="operation drainage">
                <el-button
                  class="mwow-button success large"
                  @click="handleAddDescriptionInput()"
                >
                  <span>文本框 +</span>
                </el-button>
              </div>
            </el-form-item>

            <el-form-item label="活动说明:" v-else class="item7">
              <el-input
                placeholder="请填写活动说明"
                v-model="activityContentData.descriptionValue"
              ></el-input>
            </el-form-item>
          </template>
        </template>
        <div class="hr"></div>
        <el-form-item>
          <div class="operation left">
            <el-button class="mwow-button-filled large" @click="handleViewForm">
              预览
            </el-button>
            <el-button
              class="mwow-button-filled success large"
              @click="handleNextStep"
              v-if="currentStep === 'activityInfo'"
              >下一步</el-button
            >
            <el-button
              class="mwow-button-filled large"
              @click="handlePreStep"
              v-if="currentStep === 'promotionSetting'"
              >返回上一步</el-button
            >
            <el-button
              class="mwow-button-filled success large"
              @click="handleSave"
              v-if="currentStep === 'promotionSetting'"
              >保存</el-button
            >
          </div>
        </el-form-item>
      </el-form>

      <div class="right-content">
        <appear-source-dialog
          :originData="appearSourceData"
          @change="handleAppearSourceChange"
        ></appear-source-dialog>
        <attend-staff-dialog
          :originData="market_staff_list"
          @change="handleAttendStaffChange"
          style="height: 100%"
        ></attend-staff-dialog>
      </div>
    </div>

    <!-- 添加表单项 -->
    <el-dialog
      destroy-on-close
      :visible.sync="customDialogVisible"
      :title="`自定义${currentTitle}`"
      width="400px"
      class="add-dialog"
      @close="handleCloseCustomDialog"
      :close-on-click-modal="false"
    >
      <el-form :model="customFormData">
        <el-form-item>
          <el-input
            :placeholder="`请填写${currentTitle}标题，最多8个字`"
            v-model="customFormData.title"
            maxlength="8"
          >
          </el-input>
        </el-form-item>

        <el-form-item>
          <div class="tip">
            <div>是否必填：</div>
            <el-switch v-model="customFormData.is_require"></el-switch>
          </div>
        </el-form-item>

        <el-form-item v-if="currentCustom === 'radio'" class="item-radio">
          <div
            class="item"
            v-for="(item, index) in customFormData.customRadio"
            :key="`radio` + index"
          >
            <div class="tip del">
              <div>选项{{ index + 1 }}</div>
              <div class="del" @click="delItem(item)">✖</div>
            </div>
            <!-- 最多限制26字 -->
            <el-input
              type="text"
              placeholder="请填写选项内容，最多26字"
              maxlength="26"
              v-model="item.label"
            >
            </el-input>
          </div>
          <div class="add-item" @click="addItem">
            <el-button class="mwow-button success large bg">
              <span>添加选项 +</span>
            </el-button>
          </div>
        </el-form-item>

        <el-form-item v-if="currentCustom === 'checkbox'" class="item-radio">
          <div
            class="item"
            v-for="(item, index) in customFormData.customCheckbox"
            :key="'checkbox' + index"
          >
            <div class="tip del">
              <div>选项</div>
              <div class="del" @click="delItem(item)">✖</div>
            </div>
            <!-- 最多限制26字 -->
            <el-input
              type="text"
              placeholder="请填写选项内容，最多26字"
              maxlength="26"
              v-model="item.label"
            >
            </el-input>
          </div>
          <div class="add-item" @click="addItem">
            <el-button class="mwow-button success large bg">
              <span>添加选项 +</span>
            </el-button>
          </div>
        </el-form-item>

        <el-form-item class="right">
          <el-button class="mwow-button-filled large" @click="cancelSubmit">
            取消
          </el-button>
          <el-button
            class="mwow-button-filled success large"
            @click="addSubmit"
          >
            {{ editButtonText ? "编辑" : "添加" }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <view-activity-dialog
      :originData="activityContentData"
      :visible="viewActivityDialogVisible"
      style="margin-right: 10px"
      @change="handleChange"
    >
    </view-activity-dialog>

    <open-online-pay-dialog
      :visible="openOnlinePayVisible"
      @change="handleOpenOnlinePayChange"
    >
    </open-online-pay-dialog>
  </div>
</template>
<script>
import {
  addActivityApi,
  editActivityApi,
  getActivityDetailApi,
  getActivityTypeListApi,
  getActivityPresetFormListApi,
} from "@/api/marketActivity";
import viewActivityDialog from "./viewActivityDialog.vue";
import imageVideoUploader from "@/components/imageVideoUploader.vue";
import openPay from "./openPay.vue";
import openOnlinePayDialog from "@/components/openOnlinePayDialog.vue";
import appearSourceDialog from "./appearSourceDialog.vue";
import attendStaffDialog from "./attendStaffDialog.vue";
import { dateFormat } from "@/utils/timeFormat";
import { __video_metadata_thumbnails__ } from "@/utils/video-metadata-thumbnails.iife.js";
import { UserModule } from "@/store/module/user";

export default {
  name: "addActivity",
  components: {
    viewActivityDialog,
    imageVideoUploader,
    appearSourceDialog,
    attendStaffDialog,
    openPay,
    openOnlinePayDialog,
  },
  data() {
    return {
      activity_id: 0, // 新增 / 编辑
      currentStep: "activityInfo",
      // 整体表单数据
      activityContentData: {
        type: "",
        title: "",
        stock: "",
        cover_list: {
          annex_type: 1,
        }, // 封面图片
        form_list: [], // 表单数据
        promotion: {
          title: "",
          quotation: "",
        }, // 引流数据
        image_list: [],
        desc_list: [],
        descriptionValue: "", // 推广说明自定义文本
        radio: [],
        checkbox: [],
        is_pay: false, // 是否开启支付
        time: [],
        goods_list: [], // 活动课包
        combo_list: [], // 标准课程
      },
      viewActivityDialogVisible: false, // 预览弹窗
      customDialogVisible: false, // 自定义表单弹窗
      currentCustom: "", // 表单项类型
      currentTitle: "", // 自定义表单弹窗名称
      editButtonText: false, // 自定义表单按钮文案
      eidtIndex: 0, // 编辑表单项下表
      // 暂存第二页的引流表单数据
      customFormData: {
        title: "",
        is_require: false,
        is_show: false,
        customRadio: [
          {
            label: "",
          },
          {
            label: "",
          },
        ], // 自定义单选
        customCheckbox: [
          {
            label: "",
          },
          {
            label: "",
          },
        ], // 自定义多选
      },
      viewImagePromotionUrl: "",
      descriptionInput: true,
      activityTypeList: [],
      copyDescList: [], // 判断非文本类型的长度
      sourceNode: "", // 拖动的当前元素
      market_staff_list: [],
      // 处理视频回传时的空白间隔
      imageVideoUploaderData: {
        receiveResourceCover: false,
        receiveResourcePromotion: false,
      },
      percent: 0, // 上传进度，控制资源上传
      uploading: false, // 控制资源获取
      currentImageScale: true, // 图片比例
      currentVideoScale: true, // 视频比例
      appearSourceData: {
        appear_id: "",
        source_id: "",
      },
      payData: {
        goods_list: [],
        combo_list: [],
        product_type: "1",
        edit: false, // 控制 diabled 属性是否可用
      },
      attendStaffData: [],
      openOnlinePayVisible: false, // 开通乐沃收银 dialog
      // 过去日期不可选
      effectiveDate: {
        disabledDate(date) {
          return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
    };
  },
  computed: {
    onlinePay() {
      return UserModule.userInfo.online_pay;
    },
  },
  watch: {
    activityContentData: {
      handler(newVal) {
        let nowDate = Date.now();
        if (newVal) {
          // 区分新增和编辑的日期数据
          if (typeof newVal[0] === "object") {
            if (newVal[0].getTime() === newVal[1].getTime()) {
              this.$message({
                type: "error",
                message: "活动开始时间不能和活动结束时间一致，请重新选择",
              });
              return false;
            }
            let targetDate = newVal[0].getTime();
            if (targetDate < nowDate) {
              this.$message({
                type: "error",
                message: "活动时间不能早于当前时间，请重新选择",
              });
            }
          }
        }
      },
      deep: true,
    },
  },
  created() {
    this.activity_id = Number(this.$route.query.activity_id);
    this.getActivityTypeListList("");
    if (this.activity_id) {
      getActivityDetailApi({ activity_id: this.activity_id }).then((res) => {
        this.market_staff_list = res.data.market_staff_list;
        // 表单回填
        res.data.form_list.forEach((item, index) => {
          item.sort = index + 1;
          item.is_show = item.is_show === 1 ? true : false;
          item.is_require = item.is_require === 1 ? true : false;
          if (item.preset_form_id === 1) {
            item.is_show = true;
          }
          if (item.preset_form_id === 4) {
            item.is_show = true;
          }
          // 直接转化为 [{label:""}] 的数据结构
          if (item.preset_form_id > 6) {
            if (item.type > 1) {
              item.default_value = JSON.parse(item.default_value).map((it) => {
                return {
                  label: it,
                };
              });
            }
          }
        });
        this.activityContentData = {
          type: res.data.type.type_id,
          title: res.data.title,
          time: [
            dateFormat("YYYY-mm-dd HH:MM:SS", res.data.start_time * 1000),
            dateFormat("YYYY-mm-dd HH:MM:SS", res.data.end_time * 1000),
          ],
          stock: res.data.stock,
          cover_list: {
            annex_content:
              res.data.cover_list.length > 0
                ? res.data.cover_list[0].annex_content
                : "",
            annex_type:
              res.data.cover_list.length > 0
                ? res.data.cover_list[0].annex_type
                : "",
          },
          form_list: res.data.form_list,
          is_promotion: res.data.is_promotion === 1 ? true : false,
          promotion: res.data.promotion.promotion,
          image_list: res.data.promotion.image_list,
          desc_list: res.data.promotion.desc_list,
          radio: [],
          checkbox: [],
          descriptionValue: "",
          viewList: res.data.form_list,
          is_desc: false,
          is_pay: res.data.is_pay === 1 ? true : false,
          product_type: res.data.product_type,
          goods_list: res.data.goods_list,
        };
        this.payData = {
          goods_list: res.data.goods_list,
          combo_list: res.data.combo_list,
          product_type: res.data.product_type,
          edit: this.activity_id ? true : false,
        };
        this.appearSourceData = {
          appear_id: res.data.appear_id,
          source_id: res.data.source_id,
        };
        // 如果 is_promotion === 2 则 promotion 字段为空，需要将 title 和 quotation 单独初始化
        if (res.data.is_promotion === 2) {
          this.activityContentData.promotion = {
            title: "",
            quotation: "",
          };
        }
        if (res.data.promotion) {
          res.data.promotion.desc_list.forEach((item) => {
            if (item.annex_type === 3) {
              // 活动说明文本回填
              this.activityContentData.descriptionValue = item.annex_content;
              this.descriptionInput = false;
            }
          });
          // 过滤出不带 3 类型的数据，用来展示
          this.copyDescList = res.data.promotion.desc_list.filter((item) => {
            if (item.annex_type === 1) {
              this.viewImagePromotionUrl = item.annex_content;
            }
            if (item.annex_type !== 3) {
              return item;
            }
          });
          if (res.data.promotion.desc_list.length > 0) {
            this.activityContentData.is_desc = true;
          }
        }
      });
    } else {
      this.getActivityPresetFormListApiFn();
    }
  },
  methods: {
    // 获取表单预设数据
    getActivityPresetFormListApiFn() {
      getActivityPresetFormListApi().then((res) => {
        if (res.error_code === 0) {
          res.data.list.forEach((item, index) => {
            item.sort = index + 1;
            // 1 和 4 必显必填
            if (item.preset_form_id === 1) {
              item.is_show = true;
            } else if (item.preset_form_id === 4) {
              item.is_show = true;
            } else {
              item.is_show = false;
            }
            // 小于 5 的都必填
            if (item.preset_form_id <= 6) {
              item.is_require = true;
            } else {
              item.is_require = false;
            }
          });
          setTimeout(() => {
            this.activityContentData.form_list = [...res.data.list];
          }, 1000);
        }
      });
    },

    solveActivityContentDataInfo() {
      if (this.activityContentData.viewList) {
        this.activityContentData.form_list = this.activityContentData.viewList;
      }
      let params = {
        cover_list: [],
        form_list: [],
        promotion: {
          image_list: [],
          desc_list: [],
        },
      };
      let errorMessage = "";
      if (this.activityContentData.type) {
        params.type_id = this.activityContentData.type;
      } else {
        errorMessage = "请选择活动类型";
        return { params, errorMessage };
      }
      if (this.activityContentData.title) {
        params.title = this.activityContentData.title;
      } else {
        errorMessage = "请填写活动名称";
        return { params, errorMessage };
      }
      if (
        this.activityContentData.time[0] &&
        this.activityContentData.time[1]
      ) {
        if (this.activity_id) {
          params.start_time =
            new Date(this.activityContentData.time[0]).valueOf() / 1000;
          params.end_time =
            new Date(this.activityContentData.time[1]).valueOf() / 1000;
        } else {
          let nowDate = Date.now();
          let targetDate = this.activityContentData.time[0].getTime();
          params.start_time = this.activityContentData.time[0].valueOf() / 1000;
          params.end_time = this.activityContentData.time[1].valueOf() / 1000;
          if (this.currentStep === "activityInfo") {
            if (
              this.activityContentData.time[0].getTime() ===
              this.activityContentData.time[1].getTime()
            ) {
              errorMessage = "活动开始时间不能和活动结束时间一致，请重新选择";
            }
            if (targetDate < nowDate) {
              errorMessage = "活动时间不能早于当前时间，请重新选择";
            }
          }
        }
      } else {
        errorMessage = "请选择活动时间";
        return { params, errorMessage };
      }
      if (this.activityContentData.stock) {
        if (String(this.activityContentData.stock).includes(".")) {
          errorMessage = "活动库存数必须是整数";
        }
        if (this.activityContentData.stock < 1) {
          errorMessage = "活动库存数量要大于或等于1";
        }
        params.stock = Number(this.activityContentData.stock);
      } else {
        if (typeof this.activityContentData.stock === "number") {
          errorMessage = "活动库存数量要大于或等于1";
        } else {
          errorMessage = "请选择活动库存";
        }
        return { params, errorMessage };
      }
      if (this.appearSourceData.appear_id) {
        params.appear_id = this.appearSourceData.appear_id;
      } else {
        errorMessage = "请选择出现方式";
        return { params, errorMessage };
      }
      if (this.appearSourceData.source_id) {
        params.source_id = this.appearSourceData.source_id;
      } else {
        errorMessage = "请选择来源渠道";
        return { params, errorMessage };
      }

      if (this.activityContentData.cover_list.annex_content) {
        params.cover_list.push({
          annex_content: this.delPreDomain(
            this.activityContentData.cover_list.annex_content
          ),
          annex_type: this.activityContentData.cover_list.annex_type,
          sort: 1,
        });
      } else {
        // 活动封面为选填
        this.activityContentData.cover_list = {
          annex_type: 1,
        };
      }
      // 表单数据
      if (this.activityContentData.form_list) {
        params.form_list = this.activityContentData.form_list.map((item) => {
          if (item.preset_form_id > 6 && item.type !== 1) {
            if (typeof item.default_value === "object") {
              item.default_value = item.default_value.map((it) => {
                return {
                  label: it.label,
                };
              });
            }
          }
          return item;
        });
      }
      // 是否开启支付
      params.is_pay = this.activityContentData.is_pay === true ? 1 : 2;
      if (
        this.currentStep === "promotionSetting" &&
        this.activityContentData.is_pay
      ) {
        if (this.payData.product_type) {
          params.product_type = Number(this.payData.product_type);
        }
        let goods_list = [];
        let combo_list = [];
        if (
          this.payData.goods_list &&
          this.payData.goods_list.length > 0 &&
          Number(this.payData.product_type) === 1
        ) {
          goods_list = this.payData.goods_list.map((item) => {
            if (!item.name) {
              errorMessage = "课包名称不能为空";
            }
            if (String(item.stock).includes(".")) {
              errorMessage = "课包库存数值必须是整数";
            }
            if (Number(item.stock) < 0) {
              errorMessage = "课包库存数值需大于或等于0";
            }
            if (Number(item.paid_amount) < 0) {
              errorMessage = "支付金额不能为负数";
            }
            if (!item.paid_amount) {
              errorMessage = "支付金额不能为空";
            }

            return {
              id: item.id > 0 ? item.id : 0,
              good_name: String(item.name),
              paid_amount: String(item.paid_amount),
              // stock 为空时，为无穷大，is_open_stock 为 2
              is_open_stock: item.stock === "" ? 2 : 1,
              stock: Number(item.stock),
            };
          });
        }
        if (
          this.payData.combo_list &&
          this.payData.combo_list.length > 0 &&
          Number(this.payData.product_type) === 2
        ) {
          combo_list = this.payData.combo_list.map((item) => {
            if (String(item.stock).includes(".")) {
              errorMessage = "课程库存数值必须是整数";
            }
            if (Number(item.stock) < 0) {
              errorMessage = "课程库存数值需大于或等于0";
            }
            return {
              id: item.id > 0 ? item.id : 0,
              combo_product_id: Number(item.combo_product_id),
              // stock 为空时，为无穷大，is_open_stock 为 2
              is_open_stock: item.stock === "" ? 2 : 1,
              stock: Number(item.stock),
            };
          });
        }
        if (
          this.payData.goods_list.length === 0 &&
          Number(this.payData.product_type) === 1
        ) {
          errorMessage = "活动课包不能为空";
        }
        if (
          this.payData.combo_list.length === 0 &&
          Number(this.payData.product_type) === 2
        ) {
          errorMessage = "标准课程不能为空";
        }
        params.goods_list = goods_list;
        params.combo_list = combo_list;
        if (errorMessage) {
          return { params, errorMessage };
        }
      }
      // 是否开启引流
      params.is_promotion =
        this.activityContentData.is_promotion === true ? 1 : 2;
      if (
        this.currentStep === "promotionSetting" &&
        this.activityContentData.is_promotion
      ) {
        // 引流标题
        if (this.activityContentData.promotion.title) {
          params.promotion.title = this.activityContentData.promotion.title;
        } else {
          errorMessage = "请填写引流标题";
          return { params, errorMessage };
        }
        // 引流图片
        if (this.activityContentData.image_list.length > 0) {
          this.activityContentData.image_list.forEach((item) => {
            params.promotion.image_list.push({
              annex_content: this.delPreDomain(item.annex_content),
              annex_type: 1,
              sort: params.promotion.image_list.length,
            });
          });
        } else {
          errorMessage = "引流图片不能为空";
          return { params, errorMessage };
        }
      }
      // 引流语指引语
      if (this.activityContentData.promotion.quotation) {
        params.promotion.quotation =
          this.activityContentData.promotion.quotation;
      }
      // 推广说明 - 图片或视频
      if (this.activityContentData.desc_list.length > 0) {
        this.activityContentData.desc_list.forEach((item) => {
          params.promotion.desc_list.push({
            annex_content: this.delPreDomain(item.annex_content),
            annex_type: item.annex_type,
            sort: params.promotion.desc_list.length,
          });
        });
      }
      // 推广说明 - 文本
      if (this.activityContentData.descriptionValue) {
        // 数组如果有数据，判断内部是否包含 3 类型的数据，有的话直接改
        let ret = params.promotion.desc_list.some((item) => {
          if (item.annex_type === 3) {
            item.annex_content = this.activityContentData.descriptionValue;
            return true; // 返回 true 来终止遍历
          }
        });
        // 没有 3 类型的数据，就新增
        if (!ret) {
          params.promotion.desc_list.push({
            annex_content: this.activityContentData.descriptionValue,
            annex_type: 3,
            sort: params.promotion.desc_list.length,
          });
        }
      }
      // 状态字段给个默认值
      params.status = 1;
      // 市场顾问
      if (this.market_staff_list.length > 0) {
        params.market_staff_ids = this.market_staff_list.map((item) => {
          return item.staff_id;
        });
      } else {
        errorMessage = "请添加市场顾问";
        return { params, errorMessage };
      }
      return { params, errorMessage };
    },

    handleNextStep() {
      let data = this.solveActivityContentDataInfo();
      if (this.percent > 0 && this.percent < 100) {
        this.$message({
          type: "error",
          message: "资源上传中",
        });
        return false;
      }
      if (this.uploading) {
        this.$message({
          type: "error",
          message: "资源获取中",
        });
        return false;
      }
      if (data.errorMessage) {
        this.$message({
          message: data.errorMessage,
          type: "error",
        });
        return false;
      }
      this.currentStep = "promotionSetting";
    },

    handlePreStep() {
      let data = this.solveActivityContentDataInfo();
      if (this.percent > 0 && this.percent < 100) {
        this.$message({
          type: "error",
          message: "资源上传中",
        });
        return false;
      }
      if (this.uploading) {
        this.$message({
          type: "error",
          message: "资源获取中",
        });
        return false;
      }
      if (data.errorMessage) {
        this.$message({
          message: data.errorMessage,
          type: "error",
        });
        return false;
      }
      this.currentStep = "activityInfo";
    },
    // 保存
    handleSave() {
      let data = this.solveActivityContentDataInfo();
      if (this.percent > 0 && this.percent < 100) {
        this.$message({
          type: "error",
          message: "资源上传中",
        });
        return false;
      }
      if (this.uploading) {
        this.$message({
          type: "error",
          message: "资源获取中",
        });
        return false;
      }
      if (data.errorMessage) {
        this.$message({
          type: "error",
          message: data.errorMessage,
        });
        return false;
      }
      data.params.form_list.forEach((item) => {
        item.is_show = item.is_show === true ? 1 : 2;
        if (item.preset_form_id <= 6) {
          item.is_require = 1;
        } else {
          item.is_require = item.is_require === true ? 1 : 2;
        }
        if (item.preset_form_id === 2) {
          if (typeof item.default_value === "object") {
            item.default_value = JSON.stringify(item.default_value);
          }
        }
        if (item.preset_form_id === 6) {
          if (typeof item.default_value === "object") {
            item.default_value = JSON.stringify(item.default_value);
          }
        }
        if (item.preset_form_id > 6) {
          if (typeof item.default_value === "object") {
            item.default_value = JSON.stringify(
              item.default_value.map((it) => {
                return it.label;
              })
            );
          }
        }
      });
      if (this.activity_id) {
        data.params.activity_id = this.activity_id;
        setTimeout(() => {
          this.getActivityPresetFormListApiFn();
        }, 1000);
        editActivityApi(data.params).then((res) => {
          if (res.error_code === 0) {
            this.$message({
              message: "活动修改成功",
              type: "success",
            });
            setTimeout(() => {
              this.handleBack();
            }, 500);
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
            this.getActivityPresetFormListApiFn();
          }
        });
      } else {
        addActivityApi(data.params).then((res) => {
          if (res.error_code === 0) {
            this.$message({
              message: "活动添加成功",
              type: "success",
            });
            setTimeout(() => {
              this.handleBack();
            }, 500);
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
            this.getActivityPresetFormListApiFn();
          }
        });
      }
    },
    getActivityTypeListList(v) {
      getActivityTypeListApi({ page: 1, page_size: 100, title: v || "" }).then(
        (res) => {
          if (res.error_code === 0) {
            this.activityTypeList = res.data.list;
          }
        }
      );
    },
    handleStockChange(val) {
      if (val === "") {
        this.$message({
          message: "请选择活动库存",
          type: "error",
        });
      } else if (val === "0" || Number(val) < 1) {
        this.$message({
          message: "活动库存数量要大于或等于1",
          type: "error",
        });
      } else if (val.includes(".")) {
        this.$message({
          message: "活动库存必须为整数",
          type: "error",
        });
      }
    },
    // 模糊搜索 - 活动类型
    handleSearchType(v) {
      if (v.length > 18) {
        v = v.slice(0, 18);
      }
      this.getActivityTypeListList(v);
      // this.activityContentData.type = v;
    },
    // 活动类型列表下拉
    handleTypeVisible(...rest) {
      if (rest[0]) {
        this.getActivityTypeListList();
      }
    },
    // 如果重置了引流页开关，则对应的引流页数据全部清空
    handleIsPromotion(evt) {
      if (!evt) {
        this.activityContentData.promotion.quotation = "";
        this.activityContentData.promotion.title = "";
        this.activityContentData.image_list = [];
      }
    },
    // 推广说明开关
    handleIsDesc(evt) {
      this.activityContentData.is_desc = evt;
      if (!evt) {
        this.activityContentData.desc_list = [];
        this.descriptionInput = true;
        this.activityContentData.descriptionValue = "";
        this.copyDescList = [];
      }
    },
    handlePreviewImageCover() {
      const elImageCover = document.querySelector("#elImageCover");
      if (elImageCover) {
        elImageCover.click();
      }
    },
    handlePreviewImagePromotion(item) {
      this.viewImagePromotionUrl = item.annex_content;
      const elImagePromotion = document.querySelector("#elImagePromotion");
      if (elImagePromotion) {
        elImagePromotion.click();
      }
    },
    // 监听活动上传进度
    handleListenPercent(evt) {
      this.percent = evt;
    },
    handleUploading(evt) {
      this.uploading = evt;
    },
    // 拿到 file 对象，检测图片和视频的宽高是否符合限制，val 区分上传的类型
    mediaCheck(e, val) {
      // console.log(e, val);
      // 重新初始化比例数据
      this.currentVideoScale = true;
      this.currentImageScale = true;
      let type = e.file.type;
      if (type.includes("image")) {
        this.compressImage(
          e.file,
          0.5,
          (blob) => {
            const url = URL.createObjectURL(blob);
            const img = document.createElement("img");
            img.src = url;
            // document.body.appendChild(img);
          },
          val
        );
      }
      if (type.includes("video")) {
        __video_metadata_thumbnails__.getMetadata(e.file).then((metadata) => {
          // console.log("素材信息", metadata);
          let scale = (metadata.width / metadata.height).toFixed(3);
          let res = this.handleWatchScale({ scale });
          if (!res) {
            if (val === "cover") {
              this.activityContentData.cover_list.annex_content = "";
            }
            this.$message({
              message: "请上传 16:9 比例的视频",
              type: "error",
            });
            this.currentVideoScale = false;
          } else {
            this.currentVideoScale = true;
          }
        });
      }
      return true;
    },
    // 压缩图片，接收一个文件对象、压缩比例和回调函数作为参数
    compressImage(file, quality, callback, val) {
      const reader = new FileReader(); // 使用 FileReader 对象读取文件数据
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const img = new Image(); // 创建一个 Image 对象，并将图片绘制到 Canvas 上
        img.src = event.target.result;
        img.onload = () => {
          let canvas = document.createElement("canvas");
          let ctx = canvas.getContext("2d");
          canvas.width = img.width;
          canvas.height = img.height;
          let scale = (canvas.width / canvas.height).toFixed(3);
          let res = this.handleWatchScale({ scale });
          // 每个类型图片的大小和提示语都不相同
          if (val === "cover") {
            if (canvas.width < 750 || canvas.height < 422) {
              this.activityContentData.cover_list.annex_content = "";
              this.$message({
                message: "请上传大于 750 * 422 尺寸并且为 16:9 比例的图片",
                type: "error",
              });
              this.currentImageScale = false;
              return false;
            } else {
              this.currentImageScale = true;
            }
            if (!res) {
              this.activityContentData.cover_list.annex_content = "";
              this.currentImageScale = false;
              this.$message({
                type: "error",
                message: `请上传大于 750 * 422 尺寸并且为 16:9 比例的图片`,
              });
              return false;
            } else {
              this.currentImageScale = true;
            }
          }
          // 每个类型图片的大小和提示语都不相同
          if (val === "image") {
            if (canvas.width !== 650 && canvas.height !== 650) {
              this.$message({
                message: "请上传 650 * 650 尺寸的图片",
                type: "error",
              });
              this.currentImageScale = false;
              return false;
            } else {
              this.currentImageScale = true;
            }
          }
          // 每个类型图片的大小和提示语都不相同
          if (val === "desc") {
            if (canvas.width < 750) {
              this.$message({
                message: "请上传宽度大于等于 750尺寸 的图片",
                type: "error",
              });
              this.currentImageScale = false;
              return false;
            } else {
              this.currentImageScale = true;
            }
          }

          ctx.drawImage(img, 0, 0, img.width, img.height);
          //然后使用 toBlob() 方法将 Canvas 上的图像数据转换成 Blob 对象
          canvas.toBlob(
            (blob) => {
              callback(blob); // 回调函数处理压缩后的数据。
            },
            file.type,
            quality
          );
        };
      };
    },
    // 图片或视频比例
    handleWatchScale(data) {
      if (!data.scale.startsWith("1.77")) {
        return false;
      } else {
        return true;
      }
    },
    // 满足条件，开始正式上传
    handleSelected(e) {
      if (!this.currentImageScale) return; // 图片大小不对
      if (!this.currentVideoScale) return; // 视频比例不对
      e.start();
    },
    // 封面图片或视频回调
    handleImageVideoUploader(data) {
      // 处理视频回传时的空白间隔
      this.imageVideoUploaderData.receiveResourceCover =
        !this.imageVideoUploaderData.receiveResourceCover;
      if (data.type === 1) {
        this.activityContentData.cover_list.annex_content = data.url;
        this.activityContentData.cover_list.annex_type = data.type;
      } else if (data.type === 2) {
        this.activityContentData.cover_list.annex_content = data.url;
        this.activityContentData.cover_list.annex_type = data.type;
      }
      this.$message({
        message: "上传成功",
        type: "success",
      });
      this.handleResetUploadStatus();
    },

    handleImageVideoClear() {
      this.activityContentData.cover_list.annex_type = 1;
      this.$message({
        type: "success",
        message: "删除成功",
      });
      this.handleResetUploadStatus();
    },
    // 引流、推广图片或视频回调
    handleImageUploader(...rest) {
      this.imageVideoUploaderData.receiveResourcePromotion =
        !this.imageVideoUploaderData.receiveResourcePromotion;
      if (rest[1] === "image_list") {
        this.viewImagePromotionUrl = rest[0].url;
        this.activityContentData.image_list.push({
          annex_content: rest[0].url,
          annex_type: 1,
          sort: this.activityContentData.image_list.length + 1,
        });
        this.$message({
          message: "上传成功",
          type: "success",
        });
        this.handleResetUploadStatus();
      }
      if (rest[1] === "desc_list") {
        if (rest[0].type === 1) {
          this.handleDescList(rest[0]);
        } else if (rest[0].type === 2) {
          this.handleDescList(rest[0]);
        }
        this.$message({
          message: "上传成功",
          type: "success",
        });
        this.handleResetUploadStatus();
      }
    },
    // 处理推广说明的资源
    handleDescList(data) {
      this.activityContentData.desc_list.push({
        annex_content: data.url,
        annex_type: data.type,
        sort: this.activityContentData.desc_list.length + 1,
      });
      this.activityContentData.promotion.desc_list =
        this.activityContentData.desc_list;
      // 过滤出不带 3 类型的数据
      this.copyDescList = this.activityContentData.desc_list.filter((item) => {
        if (item.annex_type === 1) {
          this.viewImagePromotionUrl = item.annex_content;
        }
        if (item.annex_type !== 3) {
          return item;
        }
      });
    },
    handleImageClear(...rest) {
      if (rest[1] === "image_list") {
        this.activityContentData.image_list.splice(rest[0], 1);
        this.$message({
          type: "success",
          message: "删除成功",
        });
      }
      if (rest[1] === "desc_list") {
        this.activityContentData.desc_list.splice(rest[0], 1);
        this.copyDescList.splice(rest[0], 1);
        this.$message({
          type: "success",
          message: "删除成功",
        });
      }
      this.handleResetUploadStatus();
    },
    // 重置资源上传数据，（上传成功、删除成功时）
    handleResetUploadStatus() {
      this.percent = 0;
      this.uploading = false;
    },

    handleViewForm() {
      this.viewActivityDialogVisible = true;
      if (!this.activityContentData.viewList) {
        this.activityContentData.viewList = this.activityContentData.form_list;
      }
    },
    handleChange() {
      this.viewActivityDialogVisible = false;
    },
    handleCustomDialog(v) {
      this.customDialogVisible = true;
      this.editButtonText = false;
      this.updateCustomDialogType(v);
    },
    updateCustomDialogType(v) {
      this.currentCustom = v;
      if (v === "input") {
        this.currentTitle = "文本框";
      }
      if (v === "radio") {
        this.currentTitle = "单选框";
      }
      if (v === "checkbox") {
        this.currentTitle = "多选框";
      }
    },
    handleAddDescriptionInput() {
      this.descriptionInput = false;
    },
    // 添加单选 / 多选项
    addItem() {
      if (this.currentCustom === "radio") {
        this.customFormData.customRadio.push({
          label: "",
        });
      }
      if (this.currentCustom === "checkbox") {
        this.customFormData.customCheckbox.push({
          label: "",
        });
      }
      this.$message({
        message: "添加成功",
        type: "success",
      });
    },
    // 删除单选 / 多选项
    delItem(item) {
      if (this.currentCustom === "radio") {
        if (this.customFormData.customRadio.length <= 2) {
          return this.$message({
            message: "删除失败，至少有两个选项",
            type: "warning",
          });
        }
        let index = this.customFormData.customRadio.indexOf(item);
        if (index === 0 || index === 1) {
          return this.$message({
            message: "第一项和第二项为默认选项,不能被删除",
            type: "warning",
          });
        }
        this.customFormData.customRadio.splice(index, 1);
      }
      if (this.currentCustom === "checkbox") {
        if (this.customFormData.customCheckbox.length <= 2) {
          return this.$message({
            message: "删除失败，至少有两个选项",
            type: "warning",
          });
        }
        let index = this.customFormData.customCheckbox.indexOf(item);
        if (index === 0 || index === 1) {
          return this.$message({
            message: "第一项和第二项为默认选项,不能被删除",
            type: "warning",
          });
        }
        this.customFormData.customCheckbox.splice(index, 1);
      }
    },
    // 提交单选 / 多选项
    addSubmit() {
      // this.customDialogVisible = false;
      if (!this.customFormData.title) {
        this.$message({
          type: "warning",
          message: "请输入标题",
        });
        return false;
      }
      let errorMessage = false;
      this.activityContentData.form_list.map((item, index) => {
        if (item.title === this.customFormData.title) {
          // 如果编辑的是本身，则不用弹窗提示
          if (index !== this.eidtIndex) {
            this.$message({
              type: "warning",
              message: "该表单项已存在，不能重复添加",
            });
            errorMessage = true;
          }
        }
      });
      if (errorMessage) {
        return false;
      }
      // false 为新增
      if (!this.editButtonText) {
        if (this.currentCustom === "input") {
          this.activityContentData.form_list.push({
            preset_form_id: this.activityContentData.form_list.length + 1,
            type: 1,
            title: this.customFormData.title,
            default_value: "",
            is_require: this.customFormData.is_require,
            is_show: this.customFormData.is_show,
            sort: this.activityContentData.form_list.length,
          });
        }
        if (this.currentCustom === "radio") {
          let res = this.handleIsEmptyItem("radio");
          if (!res) return;
          // 用于页面数据展示
          this.activityContentData.radio.push({
            title: this.customFormData.title,
            is_require: this.customFormData.is_require,
            is_show: this.customFormData.is_show,
            customRadio: this.customFormData.customRadio,
          });
          // 用于表单数据提交
          this.activityContentData.form_list.push({
            preset_form_id: this.activityContentData.form_list.length + 1,
            type: 2,
            title: this.customFormData.title,
            default_value: this.customFormData.customRadio,
            is_require: this.customFormData.is_require,
            is_show: this.customFormData.is_show,
            sort: this.activityContentData.form_list.length + 1,
          });
        }
        if (this.currentCustom === "checkbox") {
          let res = this.handleIsEmptyItem("checkbox");
          if (!res) return;
          this.activityContentData.checkbox.push({
            title: this.customFormData.title,
            is_require: this.customFormData.is_require,
            is_show: this.customFormData.is_show,
            customCheckbox: this.customFormData.customCheckbox,
          });
          this.activityContentData.form_list.push({
            preset_form_id: this.activityContentData.form_list.length + 1,
            type: 3,
            title: this.customFormData.title,
            default_value: this.customFormData.customCheckbox,
            is_require: this.customFormData.is_require,
            is_show: this.customFormData.is_show,
            sort: this.activityContentData.form_list.length + 1,
          });
        }
        this.$message({
          type: "success",
          message: "添加成功",
        });
      } else {
        this.activityContentData.form_list[this.eidtIndex].title =
          this.customFormData.title;
        this.activityContentData.form_list[this.eidtIndex].is_require =
          this.customFormData.is_require;
        if (this.currentTitle === "单选框") {
          let res = this.handleIsEmptyItem("radio");
          if (!res) return;
          // 编辑后的数据赋值
          this.activityContentData.form_list[this.eidtIndex].default_value =
            this.customFormData.customRadio;
        }
        if (this.currentTitle === "多选框") {
          let res = this.handleIsEmptyItem("checkbox");
          if (!res) return;
          // 编辑后的数据赋值
          this.activityContentData.form_list[this.eidtIndex].default_value =
            this.customFormData.customCheckbox;
        }
        this.$message({
          type: "success",
          message: "编辑成功",
        });
      }
      this.handleCloseCustomDialog();
    },
    // 编辑表单项
    editFormItem(item) {
      // 只能编辑自定义的表单项
      if (item.preset_form_id > 6) {
        this.editButtonText = true;
        this.customDialogVisible = true;
        this.customFormData.title = item.title;
        this.customFormData.is_require = item.is_require;
        // this.customFormData.is_show = item.is_show;
        // 找到单击表单项的位置
        this.eidtIndex = this.activityContentData.form_list.indexOf(item);
        if (item.type === 1) {
          this.updateCustomDialogType("input");
        }
        if (item.type === 2) {
          this.updateCustomDialogType("radio");
          // 回填数据
          let defaultValue =
            this.activityContentData.form_list[this.eidtIndex].default_value;
          if (typeof defaultValue === "object") {
            this.customFormData.customRadio = defaultValue.map((item) => {
              return {
                label: item.label,
              };
            });
          } else {
            this.customFormData.customRadio = JSON.parse(defaultValue).map(
              (item) => {
                return {
                  label: item.label,
                };
              }
            );
          }
        }
        if (item.type === 3) {
          this.updateCustomDialogType("checkbox");
          let defaultValue =
            this.activityContentData.form_list[this.eidtIndex].default_value;
          // 回填数据
          if (typeof defaultValue === "object") {
            this.customFormData.customCheckbox = defaultValue.map((item) => {
              return {
                label: item.label,
              };
            });
          } else {
            this.customFormData.customCheckbox = JSON.parse(defaultValue).map(
              (item) => {
                return {
                  label: item.label,
                };
              }
            );
          }
        }
      }
    },
    // 判断是否有空的表单项
    handleIsEmptyItem(evt) {
      if (evt === "radio") {
        let res = this.customFormData.customRadio.some((item) => {
          if (item.label === "") {
            return true;
          }
        });
        if (res) {
          this.$message({
            message: "请补全选项内容",
            type: "error",
          });
          return false;
        } else {
          for (let i = 0; i < this.customFormData.customRadio.length - 1; i++) {
            for (
              let j = i + 1;
              j <= this.customFormData.customRadio.length - 1;
              j++
            ) {
              if (
                this.customFormData.customRadio[i].label ===
                this.customFormData.customRadio[j].label
              ) {
                this.$message({
                  message: "有重复的选项内容",
                  type: "error",
                });
                return false;
              }
            }
          }
          return true;
        }
      } else if (evt === "checkbox") {
        let res = this.customFormData.customCheckbox.some((item) => {
          if (item.label === "") {
            return true;
          }
        });
        if (res) {
          this.$message({
            message: "请补全选项内容",
            type: "error",
          });
          return false;
        } else {
          for (
            let i = 0;
            i < this.customFormData.customCheckbox.length - 1;
            i++
          ) {
            for (
              let j = i + 1;
              j <= this.customFormData.customCheckbox.length - 1;
              j++
            ) {
              if (
                this.customFormData.customCheckbox[i].label ===
                this.customFormData.customCheckbox[j].label
              ) {
                this.$message({
                  message: "有重复的选项内容",
                  type: "error",
                });
                return false;
              }
            }
          }
          return true;
        }
      }
    },
    // 取消
    cancelSubmit() {
      this.handleCloseCustomDialog();
    },
    handleCloseCustomDialog() {
      this.customDialogVisible = false;
      // 重新初始化
      setTimeout(() => {
        this.customFormData = {
          title: "",
          is_require: false,
          is_show: false,
          customRadio: [
            {
              label: "",
            },
            {
              label: "",
            },
          ],
          customCheckbox: [
            {
              label: "",
            },
            {
              label: "",
            },
          ],
        };
      }, 100);
    },
    // 监听拖动开始（事件委托）
    handleDragstart(e) {
      this.sourceNode = e.target;
      e.dataTransfer.effectAllowed = "move";
    },
    // 监听拖动完成（事件委托）
    handleDragover(e) {
      e.preventDefault();
    },
    // 监听拖动进入（事件委托）
    handleDragenter(e) {
      e.preventDefault();
      if (this.sourceNode.className !== "li") {
        return;
      }
      let list = document.querySelector(".ul");
      let tip = document.querySelector(".ul .title .tip");
      // 排除父元素和自身的情况
      if (e.target === list || e.target.parentNode === this.sourceNode || tip) {
        return;
      }
      if (e.target.parentNode === list) {
        return;
      }
      // 转换为数组，拿到对应元素的下标
      let children = Array.from(list.children);
      let sourceIndex = children.indexOf(this.sourceNode);
      let targetIndex = children.indexOf(e.target.parentNode);
      if (targetIndex === -1) return false;
      // 往下拖动，将当前元素插入到目标元素的下一个位置,（注意 title dom节点）
      if (sourceIndex < targetIndex) {
        list.insertBefore(
          this.sourceNode,
          e.target.parentNode.className === "li"
            ? e.target.parentNode.nextElementSibling
            : e.target.parentNode.parentNode.nextElementSibling
        );
      }
      // 往上拖动，将当前元素插入到目标元素的位置
      if (sourceIndex > targetIndex) {
        try {
          list.insertBefore(
            this.sourceNode,
            e.target.parentNode.className === "li"
              ? e.target.parentNode
              : e.target.parentNode.parentNode
          );
        } catch (err) {
          err;
        }
      }
      let preset_form_id = document.querySelectorAll(".ul .li .preset_form_id");
      let arrId = []; // 记录拖拽位置后的 preset_form_id
      preset_form_id.forEach((item) => {
        arrId.push(Number(item.innerHTML - 1));
      });

      let copy = [];
      // 编辑回填排序
      if (this.activity_id) {
        arrId.forEach((item, index) => {
          for (let i = 0; i < this.activityContentData.form_list.length; i++) {
            if (
              item + 1 ===
              this.activityContentData.form_list[i].preset_form_id
            ) {
              copy[index] = this.activityContentData.form_list[i];
              copy[index].sort = index + 1; // 将 copy 的 sort 字段重新排序
              continue;
            }
          }
        });
      } else {
        // 新增排序
        arrId.forEach((item, index) => {
          copy[index] = this.activityContentData.form_list[item];
          // 直接修改原数组的 sort
          this.activityContentData.form_list[item].sort = index + 1;
        });
      }
      this.activityContentData.viewList = copy;
    },
    handleOpenPayClick() {
      this.openOnlinePayVisible = true;
    },
    handleOpenOnlinePayChange() {
      this.openOnlinePayVisible = false;
    },
    handleAppearSourceChange(evt) {
      this.appearSourceData.appear_id = evt.appear_id;
      this.appearSourceData.source_id = evt.source_id;
    },
    handleAttendStaffChange(evt) {
      this.market_staff_list = evt;
    },
    // 去域名前缀
    delPreDomain(url) {
      if (url) {
        let ret = url.split("/");
        return ret[ret.length - 1];
      }
    },
    handleBack() {
      this.$router.push({
        name: "activityManagement",
      });
    },
    handleDataChange(evt) {
      this.payData = evt;
      this.activityContentData.product_type = evt.product_type;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
}
.detail-head {
  display: flex;
  margin: 16px 72px;
}
/deep/.activity-type {
  margin: 0 auto;
  padding: 15px 20px;
  width: 1050px;
  display: flex;

  .left-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    border: 1px solid #f3f3f3;
    border-radius: 10px;
    overflow: hidden;
    .el-form-item {
      margin: 0 0 10px 0;
      width: 560px;
    }
    .el-form-item__label {
      min-width: 110px;
    }
    .require {
      .el-form-item__label {
        min-width: 110px;
        &::before {
          content: "*";
          color: #f56c6c;
          margin-right: 4px;
        }
      }
    }
    .el-form-item__content {
      line-height: 0px;
      width: 80%;
      margin-bottom: 10px;
      .el-radio {
        margin: 7px 20px 0 0;
      }
      .el-checkbox {
        margin: 7px 20px 0 0;
      }
    }
    .el-select {
      width: 100% !important;
    }
    .drainage {
      display: block !important;
      margin-left: 30px;
    }
    .title-level1 {
      background: rgb(242, 246, 250);
      width: 100%;
      .el-form-item__label {
        min-width: 80px !important;
        color: rgba(92, 93, 94, 1);
        font-weight: 700;
        font-size: 14px;
        padding: 5px 20px;
      }
    }
    .title-level2 {
      .el-form-item__label {
        min-width: 80px !important;
        font-weight: 700;
        color: rgba(92, 93, 94, 1);
        font-size: 14px;
        padding-left: 21px;
      }
    }
    .unOpenPay {
      .unOpenPay-text {
        margin-left: 15%;
        color: #5c5d5e;
      }
      .el-button {
        margin-left: 30%;
        margin-top: 10px;
      }
    }
    .activity-time {
      .el-date-editor {
        height: 30px !important;
        width: 100% !important;
        .el-range-input {
          font-size: 12px !important;
        }
        .el-input__icon {
          line-height: 24px !important;
        }
        .el-range-separator {
          line-height: 24px !important;
          font-size: 12px !important;
        }
      }
    }
    .item7 {
      width: 100%;
      height: 30px !important;
      margin: 0 !important;
    }

    .operation {
      padding-left: 80px;
      display: flex;
      justify-content: center;

      .bg {
        background: rgba(240, 253, 250, 1);
        width: 80px;
        height: 28px;
      }
    }

    .left {
      justify-content: flex-start;
    }
    .customInput {
      .el-form-item__content {
        // display: flex;
        .el-input {
          width: 91%;
        }
      }
    }
  }
  .right-content {
    width: 300px;
    display: flex;
    flex-direction: column;
    margin-left: 20px;
    .el-form-item {
      padding: 0 10px;
      margin-bottom: 15px;
    }
    .require {
      .el-form-item__label {
        &::before {
          content: "*";
          color: #f56c6c;
          margin-right: 4px;
        }
      }
    }
    .title-level1 {
      background: rgb(242, 246, 250);
      border-radius: 10px 10px 0 0;
      .el-form-item__content {
        display: flex;
        justify-content: flex-end;
      }
      .el-form-item__label {
        min-width: 80px !important;
        color: rgba(92, 93, 94, 1);
        font-weight: 700;
        font-size: 14px;
        padding: 5px 10px;
      }
    }
    .appear-content {
      border: 1px solid #f3f3f3;
      margin-bottom: 20px;
      border-radius: 10px;
    }
    .attend-content {
      border-radius: 10px;
      border: 1px solid #f3f3f3;
      display: flex;
      flex-direction: column;
      height: 100%;
      .content {
        flex: 1;
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 4px;
        }
        &::-webkit-scrollbar-track {
          width: 4px;
          background: none;
        }
        &::-webkit-scrollbar-thumb {
          width: 4px;
          background: #d8d8d8;
          border-radius: 2px;
        }
        .item {
          padding: 3px 10px;
          display: flex;
          margin-bottom: 10px;

          .info {
            flex: 1;
            .name {
              color: rgba(92, 93, 94, 1);
            }
            .mobile {
              color: #07d1aa;
            }
          }
          .del:hover {
            cursor: pointer;
          }
        }
      }
    }
  }

  .tip {
    height: 22px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #5c5d5e;
    .custom {
      flex: 1;
      position: relative;
      span {
        position: absolute;
        left: -65px;
      }
    }
    .desc {
      color: rgba(7, 209, 170, 1);
    }
  }
}
.uploader {
  border: 1px solid #e7e8ea;
  border-radius: 6px;
  z-index: 1;
  font-size: 0;
  overflow: hidden;
}
.cover-uploader {
  width: 377px;
  height: 211px;
}
.promotion-uploader {
  width: 120px;
  height: 120px;
}
.desc-uploader {
  width: 180px;
  height: 102px;
  img {
    object-fit: contain;
  }
  video {
    object-fit: contain;
  }
}
.ul {
  margin-top: 10px;
  .li {
    height: 20px;
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 7px 10px;
    background: rgba(246, 250, 252, 1);
    border-radius: 5px;
    .title {
      height: 20px;
      line-height: 20px;
      flex: 1;
    }
  }
}

/deep/.add-dialog {
  .el-dialog__body {
    padding: 0 !important;
  }
}
.add-dialog {
  .el-form {
    padding: 20px 20px 0 20px;
    .el-form-item {
      padding: 0 20px;
    }
    .tip {
      height: 22px;
      display: flex;
      align-items: center;
      .del:hover {
        cursor: pointer;
      }
    }
    .del {
      justify-content: space-between;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      button {
        margin-bottom: 10px;
      }
    }
    .item {
      margin-bottom: 20px;
    }
    .item-radio {
      padding: 10px 20px;
      background: #f6fafc;
    }
    .add-item {
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 14px;
      cursor: pointer;
      .bg {
        background: #07d1aa !important;
        width: 100px;
        height: 28px;
        color: white !important;
        border-radius: 4px;
        line-height: 28px;
        text-align: center;
      }
    }
  }
}

/deep/.com-wrap {
  .el-dialog__header {
    text-align: left !important;
  }
}

.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  div:nth-child(1) {
    width: 78%;
  }
}

.hr {
  border: 1px solid #f3f3f3 !important;
  width: 90%;
  margin: 15px auto;
}
</style>
